import { render } from "./GenericButton.vue?vue&type=template&id=f3d9307a&ts=true"
import script from "./GenericButton.vue?vue&type=script&lang=ts"
export * from "./GenericButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__